import { Action } from "domain/aangifte";
import { rubriekenFp, rubriekFp } from "domain/rubriek";
import { array, option } from "fp-ts";
import { pipe } from "fp-ts/lib/function";
import { RubriekReducer } from "../rubriekenReducer";

export const runMutuallyExclusiveFieldRules = (action: Action) => (rubrieken: RubriekReducer): RubriekReducer => {
  switch (action.type) {
    case "UPDATE_RUBRIEK_VALUE":
      return pipe(
        rubrieken,
        rubriekenFp.lookup(action.code),
        option.map((rubriek) =>
          pipe(
            rubriek.mutExclWith,
            array.reduce(rubrieken, (acc, mutExcl) =>
              pipe(
                acc,
                rubriekenFp.modifyAt(mutExcl.toString(), rubriekFp.clearValue),
                option.getOrElse(() => acc)
              )
            )
          )
        ),
        option.getOrElse(() => rubrieken)
      );
    default:
      return rubrieken;
  }
};
